import React from 'react';
import { getScriptSureSessiontoken } from 'api/textVisit';
import { TScriptSureSessiontoken } from 'types/textVisit';

let globalData: TScriptSureSessiontoken;

const useGetScriptSureToken = (autoFetch = true): [TScriptSureSessiontoken, boolean, () => void] => {
    const loading = React.useRef(false);
    const [items, setItems] = React.useState<TScriptSureSessiontoken>(globalData);
    const fetchData = async () => {
        try {
            loading.current = true;
            const result = await getScriptSureSessiontoken();
            if (!result.error) {
                const data: TScriptSureSessiontoken = result?.data?.data;
                globalData = data;
                setItems(data);
            }
            loading.current = false;
        } catch (e) {
            console.error(e);
            loading.current = false;
        }
    };
    React.useEffect(() => {
        if (autoFetch && !loading.current) {
            fetchData();
        }
    }, [autoFetch]);

    return [items, loading.current, fetchData];
};

export default useGetScriptSureToken;
